import React from "react";
import service1 from "../assets/IS1.png";
import service2 from "../assets/IS2.png";
import service3 from "../assets/IS3.png";
import service4 from "../assets/IS4.png";

export default function Services() {
    // Reusable gradient object for clean code
    const blueGradient = {
        background: "linear-gradient(0deg, #0E1072 0%, rgba(14, 16, 114, 0.2) 50%, rgba(14, 16, 114, 0) 100%)"
    };

    return (
        <section className="bg-[#EAF2FF] py-20">

            <div className="max-w-7xl mx-auto px-6 md:px-12">

                {/* HEADER */}
                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 mb-12">

                    <div>
                        <p className="text-[14] tracking-widest text-[#005AAC] font-semibold uppercase">
                            Curated Experiences
                        </p>

                        <h2
                            className="text-[36px] md:text-[40px] font-bold mt-2 text-transparent bg-clip-text"
                            style={{
                                background: "linear-gradient(150.27deg, #0A3FB6 -29.62%, #2FB4FF 143.23%)",
                                WebkitBackgroundClip: "text", // Required for Safari/Chrome support
                                WebkitTextFillColor: "transparent" // Extra insurance for gradient rendering
                            }}
                        >
                            Innovation Services
                        </h2>

                    </div>

                    <p className="text-right text-gray-600 max-w-md text-[16] md:text-base">
                        Blending traditional expertise with modern aesthetic technology to deliver results that transcend the ordinary.
                    </p>
                </div>

                {/* BENTO GRID */}
                <div className="grid md:grid-cols-4 gap-6 auto-rows-[250px]">

                    {/* LEFT BIG CARD */}
                    <div className="md:col-span-2 md:row-span-2 relative rounded-2xl overflow-hidden shadow-lg">

                        <img
                            src={service1}
                            alt="Hair Specialist"
                            className="w-full h-full object-cover"
                        />

                        {/* UPDATED BLUE GRADIENT */}
                        <div className="absolute inset-0" style={blueGradient}></div>

                        <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 text-white z-10 max-w-[75%] md:max-w-[260px]">
                            <h3 className="text-[30px] md:text-[28px] font-bold mb-2">Hair Specialist</h3>
                            <p className="text-[16] md:text-sm text-gray-200 mb-6 leading-relaxed">
                                Precision cuts, custom color, and transformative styling sessions.
                            </p>

                            <button className="bg-[#F8D247] hover:bg-[#e5c03c] text-black px-5 py-2.5 rounded-lg text-sm font-bold flex items-center gap-2 transition-colors w-max">
                                Download App
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* TOP RIGHT CARD */}
                    <div className="md:col-span-2 md:row-span-1 relative rounded-2xl overflow-hidden shadow-lg">

                        <img
                            src={service2}
                            alt="K-Sense Face Rituals"
                            className="w-full h-full object-cover"
                        />

                        {/* UPDATED BLUE GRADIENT */}
                        <div className="absolute inset-0" style={blueGradient}></div>

                        <div className="absolute bottom-6 left-6 text-white z-10">
                            <h3 className="text-[20] font-bold mb-1">K-Sense Face Rituals</h3>
                            <p className="text-[14] text-gray-200">
                                Advanced Korean-inspired skincare protocols.
                            </p>
                        </div>
                    </div>

                    {/* BOTTOM LEFT SMALL */}
                    <div className="relative rounded-2xl overflow-hidden shadow-lg">

                        <img
                            src={service3}
                            alt="Flawless Face"
                            className="w-full h-full object-cover"
                        />

                        {/* UPDATED BLUE GRADIENT */}
                        <div className="absolute inset-0" style={blueGradient}></div>

                        <div className="absolute bottom-6 left-6 text-white text-[18] font-bold z-10">
                            Flawless Face
                        </div>
                    </div>

                    {/* BOTTOM RIGHT SMALL */}
                    <div className="relative rounded-2xl overflow-hidden shadow-lg">

                        <img
                            src={service4}
                            alt="Calm Spa"
                            className="w-full h-full object-cover"
                        />

                        {/* UPDATED BLUE GRADIENT */}
                        <div className="absolute inset-0" style={blueGradient}></div>

                        <div className="absolute bottom-6 left-6 text-white text-[18] font-bold z-10">
                            Calm Spa
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
}